import React, { useState } from 'react';
import Icon from '@avtechsoftware/react-component-library/src/components/common/Icon/Icon';
import { Col, Modal, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import ModalComponent from '../../../../layout/Modals/ModalComponent/ModalComponent';
import NotificationAction from '../../../../xlalerts/alertforms/DefineActionsSection/NotificationAction';
import NewNotificationGroupModal from '../../../../xlalerts/alertforms/DefineActionsSection/NewNotificationGroupModal';
import NewQuietTimeModal from '../../../../xlalerts/alertforms/DefineActionsSection/NewQuietTimeModal';
import NewNotificationTemplateModal
  from '../../../../xlalerts/alertforms/DefineActionsSection/NewNotificationTemplateModal';
import { selectSessionInformation } from '../../../../../redux/slices/sessionSlice';
import { selectNotificationGroupList } from '../../../../../redux/slices/notificationGroupsSlice/notificationGroupsSlice';
import { createBlankAction } from '../../../../xlalerts/alertforms/AlertFormUtility';
import Alert from '../../../../../classes/Alert';
import { connectModalContainerContextToComponent } from '../../../../../contexts/ModalContext/ModalContext';
import ClassUtility from '../../../../../utility/ClassUtility';

function CreateActionModal({
  setModalJSX, activeAlert, setActiveAlert,
}) {
  // const dispatch = useDispatch();
  const { activeSubscription } = useSelector(selectSessionInformation);
  const notificationGroupList = useSelector(selectNotificationGroupList);
  const [action, setAction] = useState(createBlankAction());
  const [showNewQuietTimeModal, setShowNewQuietTimeModal] = useState(false);
  const [showNewNotificationGroupModal, setShowNewNotificationGroupModal] = useState(false);
  const [showNewTemplateModal, setShowNewTemplateModal] = useState(false);
  const [actionIdToApplyNewProperty, setActionIdToApplyNewProperty] = useState(null);
  const [addActionBtnText, setAddActionBtnText] = useState('Add Action');
  const [show, setShow] = useState(true);
  // const [formErrors, setFormErrors] = useState([]);
  const [isReadyToSubmit, setIsReadyToSubmit] = useState(true);
  const hasAdvancedAlerting = activeSubscription.activeTierHasAdvancedAlerting === true;

  const closeModalHandler = () => {
    setShow(false);
    setModalJSX((<></>));
  };

  const onConfirmAddAction = () => {
    setAddActionBtnText('Saving...');
    setIsReadyToSubmit(false);
    // eslint-disable-next-line no-use-before-define
    // handleValidateAlertAction();
    const updatedAlert = ClassUtility.cloneObject(activeAlert);
    updatedAlert.alertActionList.push(action);
    setActiveAlert(updatedAlert);
    closeModalHandler();
  };

  const handleShowNewTemplateModal = (actionId) => {
    setActionIdToApplyNewProperty(actionId);
    setShowNewTemplateModal(true);
  };
  const handleShowNewScheduleModal = (actionId) => {
    setActionIdToApplyNewProperty(actionId);
    setShowNewQuietTimeModal(true);
  };

  const handleShowNewNotificationGroupModal = (actionId) => {
    setActionIdToApplyNewProperty(actionId);
    setShowNewNotificationGroupModal(true);
  };

  const onCreateNewNotificationGroup = (actionId) => {
    setActionIdToApplyNewProperty(actionId);
  };
  return (
    <form>
      <ModalComponent
        size="lg"
        show={show}
        close={closeModalHandler}
        showConfirmCallToAction
        confirmButtonAction={onConfirmAddAction}
        confirmButtonText={addActionBtnText}
        isBtnDisabled={!isReadyToSubmit}
        actionBtnIcon={(<Icon icon="plus" className="mr-1" />)}
      >

        <Modal.Body>
          <Row className="mb-4 mt-2">
            <Col className="ml-2">
              <NotificationAction
                key={action.id}
                action={action}
                notificationGroups={notificationGroupList}
                onUpdate={(updatedAction) => {
                  setAction(updatedAction);
                  const updatedAlert = ClassUtility.cloneObject(activeAlert);
                  updatedAlert.alertActionList.push(action);
                  setActiveAlert(updatedAlert);
                }}
                onDelete={() => {}}
                hasAdvancedAlerting={hasAdvancedAlerting}
                showNewGroupModal={handleShowNewNotificationGroupModal}
                showNewScheduleModal={handleShowNewScheduleModal}
                showNewTemplateModal={handleShowNewTemplateModal}
                onCreateNewNotificationGroup={onCreateNewNotificationGroup}
                errorList={[]}
                canDelete={false}
              />
            </Col>
          </Row>
          {!hasAdvancedAlerting && (
          <Row>
            <Col>
              <div className="alert alert-info mt-3">
                <div className="d-flex">
                  <FontAwesomeIcon icon={faInfoCircle} className="mr-1" />
                  <h6>
                    Your current account allows one action for each alert
                  </h6>
                </div>

                <p className="mt-2 ">
                  For advanced functionality including alerts that support
                  multiple actions,
                  repeat notifications, customized notification templates and
                  more, consider
                  <a
                    href="/subscription/billing/select-tier"
                    target="_blank"
                  >
                    {' '}
                    upgrading your account
                  </a>
                  .
                </p>
              </div>
            </Col>
          </Row>
          )}
          {showNewNotificationGroupModal && (
          <NewNotificationGroupModal
            show={showNewNotificationGroupModal}
            handleClose={() => setShowNewNotificationGroupModal(false)}
            actionIdToApplyGroup={actionIdToApplyNewProperty}
            onCreateNewNotificationGroup={onCreateNewNotificationGroup}
          />
          )}
          {showNewQuietTimeModal && (
          <NewQuietTimeModal
            show={showNewQuietTimeModal}
            handleClose={() => setShowNewQuietTimeModal(false)}
            actionIdToApplySchedule={actionIdToApplyNewProperty}
          />
          )}

          {showNewTemplateModal && (
          <NewNotificationTemplateModal
            show={showNewTemplateModal}
            handleClose={() => setShowNewTemplateModal(false)}
            actionIdToApplyTemplate={actionIdToApplyNewProperty}
          />
          )}
        </Modal.Body>
      </ModalComponent>
    </form>
  );
}

CreateActionModal.propTypes = {
  activeAlert: PropTypes.instanceOf(Alert).isRequired,
  setActiveAlert: PropTypes.func.isRequired,
  setModalJSX: PropTypes.func.isRequired,
};

export { CreateActionModal };
export default connectModalContainerContextToComponent(CreateActionModal);
